export const tileSize = 16;
export const screenWidth = 16;
export const screenHeight = 11;
export const mapWidth = 16;
export const mapHeight = 8;
export const numLayers = 7;
